import compareAsc from 'date-fns/compareAsc';
import compareDesc from 'date-fns/compareDesc';

const epoch = new Date('1970-01-01');

const parseDateFieldFromObject = (obj, field) => (
  obj[field] ? new Date(obj[field]) : epoch
);

export const sortAsc = (field) => (d1 = {}, d2 = {}) => (
  compareAsc(parseDateFieldFromObject(d1, field), parseDateFieldFromObject(d2, field))
);

export const sortDesc = (field) => (d1 = {}, d2 = {}) => (
  compareDesc(parseDateFieldFromObject(d1, field), parseDateFieldFromObject(d2, field))
);

export const sortBusinessEntityByName = (
  { businessEntityName: name1 },
  { businessEntityName: name2 }
) => {
  if (name1 < name2) { return -1; }
  if (name1 > name2) { return 1; }
  return 0;
};

export const sortTasksAlphabetically = (orderTasks) => (orderTasks
  .sort((a, b) => a.orderTaskType.localeCompare(b.orderTaskType)));
